module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "modal": _vm.showModal,
      "title": (_vm.formData ? 'IMPRIMIR GUIA DE ENCAMINHAMENTO OU ASO - CONSULTA Nº ' + _vm.formData.id_con : ''),
      "width": "80%"
    }
  }, [(_vm.formData) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingContent),
      expression: "loadingContent"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "color": "warning",
      "icon": "info",
      "title": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n              Disponibilizamos abaixo algumas opções para você visualizar as Guias de Encaminhamento ou o ASO dessa consulta.\r\n              "), _c('br'), _vm._v("\r\n              Certifique-se que seu navegador esteja liberado para abrir os POP-UP desse sistema. Para mais informações acesse "), _c('a', {
    attrs: {
      "href": "https://support.google.com/chrome/answer/95472?hl=pt-BR",
      "target": "_blank"
    }
  }, [_vm._v("clique aqui")])])])]), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, [(_vm.formData && _vm.formData.tipo_status.id == 54) ? _c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-guia"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir Guia de Encaminhamento")]), _vm._v(" "), (_vm.formData) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('ed-alert', {
    staticClass: "mb-3",
    attrs: {
      "type": "warning",
      "message": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n                  Esse Guia de Encaminhamento não garante atendimento na clínica. Por favor imprimir esse Guia e entregar ao funcionário para apresentar na hora do atendimento.\r\n                ")])])]), _vm._v(" "), _c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "title": "Clique Aqui para Imprimir",
      "value": "Imprimir"
    },
    on: {
      "click": _vm.onGuia
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Imprimir ASO",
      "name": "tab-aso"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Imprimir ASO")]), _vm._v(" "), (_vm.formData) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.formData && _vm.formData.id_con && (_vm.formData.tipo_status.id == 66 || _vm.formData.tipo_status.id == 67)) ? _c('ed-button', {
    attrs: {
      "icon": "fa fa-print",
      "title": "Clique Aqui para Imprimir",
      "disabled": _vm.formData.tipo_status.id != 66 && _vm.formData.tipo_status.id != 67,
      "value": "Imprimir"
    },
    on: {
      "click": _vm.onAso
    }
  }) : _c('ed-alert', {
    attrs: {
      "type": "error",
      "class_name": "q-mb-lg",
      "message": "Atenção"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\r\n                  Esse ASO ainda não foi liberado. Você será notificado por email quando o ASO estiver liberado.\r\n                  "), (_vm.formData.credenciada.tel_com) ? _c('span', [_vm._v("\r\n                    Para maiores informações entre com " + _vm._s(_vm.formData.credenciada.nome.toUpperCase()) + " pelo telefone \r\n                    " + _vm._s(_vm.formData.credenciada.tel_com) + "\r\n                  ")]) : _c('span', [_vm._v("\r\n                    Para maiores informações entre com " + _vm._s(_vm.formData.credenciada.nome.toUpperCase()) + "\r\n                  ")])])])])], 1) : _vm._e()])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fffd06ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/consulta/_includes/guia.vue
// module id = 1575
// module chunks = 45